module.exports = __webpack_public_path__ + "img/logo-rever.e11d8432.svg";